




































































































































































































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* component */
import FieldImg from '@/app/components/Field/FieldImg.vue'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import AiAdvicePlans from '@/app/components/FieldDetails/AiAdvicePlans.vue'
import Loading from '@/app/components/Common/Loading.vue'

@Component({
  components: {
    FieldImg,
    AiAdvicePlans,
    Loading
  }
})
export default class DetailsContent extends Vue {
  /* アイコン */
  private elemet1Icon: string = require('@/assets/icon/no_data.png')
  private elemet2Icon: string = require('@/assets/icon/no_data.png')
  private elemet3Icon: string = require('@/assets/icon/no_data.png')
  private elemet4Icon: string = require('@/assets/icon/no_data.png')
  private weatherIcon: string = require('@/assets/icon/weather_unknown.svg')
  private imgPath: string = ''
  /* 表示非表示 */
  private isActiveSickness: boolean = false
  private isActiveWeeds: boolean = false
  private isActivePest: boolean = false
  private isActiveTempareture: boolean = false
  private isActiveFall: boolean = false
  private isCondition: boolean = false
  private disabled: boolean = false
  private showFutureData: boolean = true
  /* データ */
  private plantingId: number = 0
  private maxIntegrationTemperature: number = 2600
  private allGraphData: {[key: number]: any } = {}
  private sensorDataList: any[] = []
  private graphData: {[key: string]: number} = {
    growth_height: 0,
    integration_temperature: 0,
    soil_moisture: 0,
    spad: 0,
    stem_number: 0,
    stem_number_m2: 0
  }
  private sensorData: any = {
    growth_stage: '-',
    growth_step: 0,
    intergration_temperature: 0,
    max_integration_temperature: 2600,
    field_status: {
      is_sick: false,
      is_weed: false,
      is_pest: false,
      is_high_temperature: false,
      is_fallen_fruit: false
    },
    element_status: {
      element1: null,
      element2: null,
      element3: null,
      element4: null
    },
    weather_status: {
      weather_code: null,
      temperature: null,
      temperature_highest: null,
      temperature_lowest: null,
      temperature_difference: null,
      solar_radiation: null,
      windy_time: null,
      humidity: null,
      rainfall: null,
      wind_velocity: null
    },
    images: [],
    date: '2021-06-10 00:00:00'
  }
  private keyDate: string = ''
  private keyWeekDay: string = ''
  private getImgKey: string = ''
  private latestDate: string = ''
  private stemNumType: string = '1'
  private isActive: string = 'growthData'

  private get dateChangeState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }
  private get setSensorDataFlag () : boolean {
    return this.$store.state.setFlagState.sensorDataFlag
  }
  private get setMaxDate (): string {
    return this.$store.state.fieldDetailsState.maxDate
  }
  private get displayYear (): number {
    return this.$store.state.fieldDetailsState.displayYear
  }
  @Watch('displayYear')
  changeDisplayYaer () {
    this.firstFlag = true
  }

  @Watch('dateChangeState')
  onDateChange (newValue: string) {
    this.displayDate(newValue)
    let plantingId = Session.getPlantingId()!
    this.plantingId = parseInt(plantingId)

    /* 画像取得APIのためのkeyを保存 */
    this.getImgKey = newValue

    this.getDetailsData(newValue)
  }
  @Watch('setSensorDataFlag')
  getFlag (flag: boolean) {
    if (flag) {
      this.getSensorData()
      /* フラグリセット */
      this.$store.commit('setFlagState/setSensorDataFlag', false)
    }
  }
  @Watch('setMaxDate')
  getMaxDate (day: string) {
    if (day !== '') {
      this.getGraphData()
    }
  }

  created () {
    this.cacheClear()
    this.$store.commit('dateChoiceState/setChangeDate', '')
    this.$store.commit('setFlagState/setSensorDataFlag', false)
  }

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? value : '-'
  }

  private async cacheClear () {
    await Session.clearSensorCache()
  }

  private getStageNum (stageName: string) {
    if (stageName === null || stageName === '-') {
      return ''
    } else {
      const num = stageName.split('.', 1)
      return num[0] + '.'
    }
  }

  private getStageName (stageName: string) {
    let name = stageName.split('.', 2)
    return name[1]
  }

  /* センサーデータをsessionStorageから取得 */
  private async getSensorData () {
    let plantingId = Session.getPlantingId()!
    this.allGraphData = JSON.parse(Session.getGraphData()!)
    let sensorDataList = await JSON.parse(Session.getSensorData(plantingId)!)
    this.stemNumType = Session.getStemNumberType()!

    if (sensorDataList !== null) {
      if (Object.keys(sensorDataList).length === 1) {
        // timestamp以外のデータがないとき
        this.keyDate = '-月-日'
        this.keyWeekDay = '-'
        this.disabled = true
      } else {
        this.sensorDataList = JSON.parse(Session.getSensorData(plantingId)!)
      }
    }
    this.getDetailsData(this.latestDate)
  }

  private createYYYYMMDD (date: string) {
    const year = String(date).slice(0, 4)
    const month = String(date).slice(5, 7)
    const day = String(date).slice(8, 10)

    return '' + year + month + day
  }

  private firstFlag: boolean = true

  private getGraphData () {
    /* 取得したデータの最新を表示 */
    if (this.allGraphData === null) {
      return
    }

    /* 取得したデータの最新、または、グラフの最終日を表示 */
    let dataLastDate: string = String(Object.keys(this.allGraphData).pop())
    let graphLastDate: number = this.formingData(this.$store.state.fieldDetailsState.maxDate)
    let keyDate: string

    if (parseInt(dataLastDate) > graphLastDate) {
      keyDate = String(graphLastDate)
    } else {
      keyDate = dataLastDate
    }
    this.latestDate = keyDate

    if (this.firstFlag) {
      this.firstFlag = false
      this.$store.commit('dateChoiceState/setChangeDate', keyDate)
      this.displayDate(keyDate)
    }

    if (this.allGraphData !== null && Object.keys(this.allGraphData).length !== 0) {
      this.getDaysTodate(keyDate)
      let plantingId = Session.getPlantingId()!

      /* 詳細データがある場合は表示 */
      if (this.allGraphData[parseInt(keyDate)]) {
        this.graphData = this.allGraphData[parseInt(keyDate)]
      }
    }
  }

  /* センサーデータ取得 */
  private getDetailsData (key:string) {
    // 全データなし
    if (this.sensorDataList.length === 0) {
      this.showFutureData = true
      return
    }
    this.sensorData = {
      growth_stage: '-',
      growth_step: 0,
      intergration_temperature: 0,
      max_integration_temperature: 2600,
      field_status: {
        is_sick: false,
        is_weed: false,
        is_pest: false,
        is_high_temperature: false,
        is_fallen_fruit: false
      },
      element_status: {
        element1: null,
        element2: null,
        element3: null,
        element4: null
      },
      weather_status: {
        weather_code: null,
        temperature: null,
        solar_radiation: null,
        windy_time: null,
        humidity: null,
        rainfall: null,
        wind_velocity: null
      },
      images: [],
      date: ''
    }

    for (var j in this.sensorDataList) {
      if (this.sensorDataList[j].date !== undefined && this.createYYYYMMDD(this.sensorDataList[j].date) === key) {
        this.maxIntegrationTemperature = this.sensorDataList[j].max_intergration_temperature
        this.sensorData = this.sensorDataList[j]
        break
      }
    }

    // データが無かったら表示
    if (this.sensorData.growth_stage === '-') {
      this.showFutureData = true
    } else {
      this.showFutureData = false
    }

    this.judgmentWorning()
    this.judgmentIconColor()
    this.judgmentGrowthImg()
    this.judgmentWeatherIcon()
    this.setImagePath()
  }

  private remainingIntegrationTemperature (val: number) {
    if (val === undefined || val === null) {
      return '-'
    } else {
      const remainingIntegrationTemp = this.maxIntegrationTemperature - this.sensorData.integration_temperature
      if (remainingIntegrationTemp < 0) {
        return 0
      } else {
        return remainingIntegrationTemp
      }
    }
  }

  /* 圃場状態アイコンの判定 */
  private judgmentWorning () {
    this.isActiveSickness = this.sensorData.field_status.is_sick
    this.isActiveWeeds = this.sensorData.field_status.is_weed
    this.isActivePest = this.sensorData.field_status.is_pest
    this.isActiveTempareture = this.sensorData.field_status.is_high_temperature
    this.isActiveFall = this.sensorData.field_status.is_fallen_fruit

    if (this.isActiveSickness || this.isActiveWeeds || this.isActivePest || this.isActiveTempareture || this.isActiveFall) {
      this.isCondition = true
    } else {
      this.isCondition = false
    }
  }

  /* 詳細アイコンの判定 */
  private judgmentIconColor () {
    if (this.sensorData.element_status.element1 === null) {
      this.elemet1Icon = require('@/assets/icon/no_data.png')
    } else {
      this.elemet1Icon = require('@/assets/icon/ico_condition1.png')
    }

    if (this.sensorData.element_status.element2 === null) {
      this.elemet2Icon = require('@/assets/icon/no_data.png')
    } else {
      this.elemet2Icon = require('@/assets/icon/ico_condition1.png')
    }

    if (this.sensorData.element_status.element3 === null) {
      this.elemet3Icon = require('@/assets/icon/no_data.png')
    } else {
      this.elemet3Icon = require('@/assets/icon/ico_condition1.png')
    }

    if (this.sensorData.element_status.element4 === null) {
      this.elemet4Icon = require('@/assets/icon/no_data.png')
    } else {
      this.elemet4Icon = require('@/assets/icon/ico_condition1.png')
    }
  }

  /* 天気アイコンの判定 */
  private judgmentWeatherIcon () {
    const weather = this.sensorData.weather_status.weather_code
    switch (weather) {
      // 晴れ
      case 1:
        this.weatherIcon = require('@/assets/icon/forecast_icon-sun_iphone.png')
        break

      // 曇り
      case 2:
        this.weatherIcon = require('@/assets/icon/forecast_icon-cloud_iphone.png')
        break

      // 雨
      case 3:
        this.weatherIcon = require('@/assets/icon/forecast_icon-rain_iphone.png')
        break

      // 雨または雪
      case 4:
        this.weatherIcon = require('@/assets/icon/forecast_icon-sleet_iphone.png')
        break

      // 雪
      case 5:
        this.weatherIcon = require('@/assets/icon/forecast_icon-snow_iphone.png')
        break

      // 不明
      default:
        this.weatherIcon = require('@/assets/icon/weather_unknown.svg')
        break
    }
  }

  /* 稲の画像判定 */
  private judgmentGrowthImg () {
    if (this.sensorData.growth_step === undefined) {
      return
    }

    if (this.sensorData.growth_step === 0) {
      let lastData = this.sensorDataList[this.sensorDataList.length - 1]
      this.sensorData.growth_step = lastData.growth_step
    }
  }

  /* 画像URL */
  private setImagePath () {
    const path = '/v1/field/image'
    let type = ''
    let id = Session.getPlantingId()!
    let date = '' + new Date().getFullYear() + (new Date().getMonth() + 1) + (new Date().getDate() - 1)

    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ type: type, planting_id: id, date: date })
    url.search = params.toString()
    this.imgPath = url.href
  }

  /* 日付と曜日の表示 */
  private displayDate (keyDate: string) {
    if (keyDate === '') {
      this.keyDate = ''
      this.keyWeekDay = ''
    } else {
      this.keyDate = DateClass.displayData(parseInt(keyDate))
      this.keyWeekDay = DateClass.setWeek(parseInt(keyDate))
    }
  }

  /* 播種日からkeyDateまでの日数を取得 */
  private getDaysTodate (keyDate: string) {
    let plantingDay: number = parseInt(Session.getPlantingDay()!)
  }

  /* 日付変更用(<、>ボタンクリック時) */
  private changeDetailDate (type: string) {
    const plantingDay = parseInt(Session.getPlantingDay()!)
    const status = parseInt(Session.getHarvestStatus()!)
    const harvestStatusDay = Session.getHarvestStatusDay()!
    const selectedDate = DateClass.formingDate(this.$store.state.dateChoiceState.changeDate)

    // 始まりを播種日-9日にする
    const minDay = DateClass.formingDate(plantingDay)
    minDay.setDate(minDay.getDate() - 9)
    const formingDate = this.formingData(minDay)
    const formingLastDate = this.formingData(this.$store.state.fieldDetailsState.maxDate)
    let maxDay = formingLastDate

    if (type === 'plus') {
      /* 現在の日付を時間に単位変換し、プラス1日する */
      let newDate = new Date(new Date(selectedDate).getTime() + 1 * 24 * 60 * 60 * 1000)
      /* 数値型に変換 */
      let setDate = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
      /* 最終日より先の日付には変更不可 */
      if (setDate <= maxDay) {
        /* スライドバーを連動 */
        this.getDaysTodate(JSON.stringify(setDate))
        /* stateに保持 */
        this.$store.commit('dateChoiceState/setChangeDate', JSON.stringify(setDate))
      }
    } else if (type === 'minus') {
      /* 現在の日付を時間に単位変換し、マイナス1日する */
      let newDate = new Date(new Date(selectedDate).getTime() - 1 * 24 * 60 * 60 * 1000)
      let setDate = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
      /* 播種日より前の日付は変更不可 */
      if (formingDate <= setDate) {
        this.getDaysTodate(JSON.stringify(setDate))
        this.$store.commit('dateChoiceState/setChangeDate', JSON.stringify(setDate))
      }
    }
  }

  private formingData (day: any) {
    const date = DateClass.toDoubleDigits(day.getFullYear()) + DateClass.toDoubleDigits(day.getMonth() + 1) + DateClass.toDoubleDigits(day.getDate())
    return parseInt(date)
  }

  /* 最大値の判定 */
  public judgeMaxDay (a: number, b:number) {
    let maxDay: any

    if (a >= b) {
      maxDay = a
    } else {
      maxDay = b
    }

    return maxDay
  }

  @Watch('tabResetFlag')
  getTabResetFlag (flag: boolean) {
    if (flag) {
      this.isActive = 'growthData'
      /* フラグリセットデータを送信 */
      this.$emit('flag-reset')
    }
  }

  @Prop() private aiAdvicePlans!: any
  @Prop() private aiAdviceName!: any
  @Prop() private showAiAdviceLoading!: boolean
  @Prop() private tabResetFlag!: boolean

  private changeTab (val: string) {
    this.isActive = val
  }
}
